import * as React from 'react';
import {
    ArrayInput,
    Create,
    Edit,
    EditButton,
    FormDataConsumer,
    FunctionField,
    ImageField,
    ImageInput,
    List,
    SimpleForm,
    SimpleFormIterator,
    TextField,
    TextInput,
} from 'react-admin';

import apiURL from '../apiURL';

import AdminPagination from '../AdminPagination';
import AdminSelectableDatagrid from '../AdminSelectableDatagrid';

const DEFAULT_CONTRACT_SECTIONS = [
    {
        title: '1. OBJET DU CONTRAT',
        text:
            "Les présentes conditions générales de location définissent les droits et obligations de Jénès Péyia Music, ci-après « le Loueur », et de toute personne physique majeure, ci-après « le Locataire », louant le matériel de sonorisation ou de karaoké désigné en page 1. Elles sont régies notamment par les articles 1103 et suivants du Code civil.",
        text_online: '',
        text_cheque: '',
    },
    {
        title: '2. RÉSERVATION & PAIEMENT',
        text:
            "La demande de réservation est effectuée en ligne. Après validation de la disponibilité par Jénès Péyia Music, le présent contrat et les conditions générales sont mis à disposition du Locataire. Leur acceptation est obligatoire avant paiement. Le paiement en ligne du montant indiqué en page 1 confirme définitivement la réservation pour la date, l'offre et les options mentionnées au contrat.",
        text_online: '',
        text_cheque: '',
    },
    {
        title: '3. DÉPÔT DE GARANTIE, CAUTION & IDENTIFICATION',
        text: '',
        text_online:
            "Un dépôt de garantie d'un montant de {{deposit_amount}} est exigé avant la remise du matériel. Il est constitué en ligne selon les modalités du prestataire de paiement utilisé. Il n'a pas vocation à être prélevé définitivement en l'absence de dommage, perte, vol, non-restitution ou autre manquement contractuel. Après restitution, un contrôle complémentaire du fonctionnement du matériel peut être effectué dans un délai maximal de 24 heures. En l'absence d'anomalie, le dépôt est libéré selon les modalités et délais du prestataire. En cas de dommage, perte, vol ou non-restitution, tout ou partie du dépôt peut être affecté aux sommes dues, sans préjudice d'un complément lorsque le préjudice réellement subi excède son montant. Le Loueur peut demander au Locataire une pièce d'identité en cours de validité correspondant à l'identité utilisée pour la réservation.",
        text_cheque:
            "Un dépôt de garantie d'un montant de {{deposit_amount}} est exigé lors de la remise du matériel, sous forme de chèque. Le chèque n'est pas encaissé en l'absence de dommage, perte, vol, non-restitution ou autre manquement contractuel. Après restitution, un contrôle complémentaire du fonctionnement du matériel peut être effectué dans un délai maximal de 24 heures. En l'absence d'anomalie, le chèque est détruit. En cas de dommage, perte, vol ou non-restitution, tout ou partie du dépôt peut être encaissé et imputé sur les sommes dues, sans préjudice d'un complément lorsque le préjudice réellement subi excède son montant. Le Loueur peut demander au Locataire une pièce d'identité en cours de validité correspondant à l'identité utilisée pour la réservation.",
    },
    {
        title: '4. DURÉE DE LOCATION & RESTITUTION',
        text:
            "La location est accordée pour une durée comprise entre 8 heures et 24 heures maximum. Le matériel doit être restitué à la date et à l'heure convenues, en bon état, propre et complet. Tout retard est soumis aux pénalités prévues à l'article 6. La prise en charge et la restitution font l'objet d'un constat de l'état du matériel. Les anomalies visibles doivent être consignées sur le contrat. Un contrôle complémentaire de fonctionnement peut être effectué dans les 24 heures suivant la restitution.",
        text_online: '',
        text_cheque: '',
    },
    {
        title: '5. RESPONSABILITÉS DU LOCATAIRE — SINISTRE, VOL & DÉGRADATION',
        text:
            "Le Locataire est pleinement responsable du matériel dès sa prise en charge et jusqu'à sa restitution complète. En cas de vol, perte ou non-restitution, la caution peut être encaissée en totalité. Le Locataire devra également s'acquitter de la valeur actuelle ou de remplacement du matériel, après prise en compte de son état d'usure, augmentée de 10 % correspondant aux frais administratifs et au manque à gagner. En cas de sinistre ou de détérioration non réparable imputable au Locataire, la réparation ou le remplacement sera facturé sur la base de la valeur résiduelle, majorée de 10 %. Aucune majoration ne sera appliquée si le Locataire établit que la panne résulte d'un vice interne du matériel. En cas de force majeure dûment justifiée, notamment vol avec agression accompagné d'un dépôt de plainte ou incendie accidentel, le Locataire pourra être dispensé de la majoration de 10 %, sans être dispensé de la valeur du matériel restant due.",
        text_online: '',
        text_cheque: '',
    },
    {
        title: '6. PÉNALITÉ DE RETARD & FACTURATION',
        text:
            "Conformément à l'article 1231-5 du Code civil, toute restitution tardive entraîne une pénalité de 10 € par heure entamée après l'heure prévue de restitution. Une journée supplémentaire est facturée en cas de dépassement de 24 heures. Au-delà de 48 heures de retard, la caution peut être encaissée en totalité et le Loueur se réserve le droit d'engager les démarches nécessaires pour non-restitution.",
        text_online: '',
        text_cheque: '',
    },
    {
        title: '7. ANNULATION & REMBOURSEMENT',
        text:
            "L'annulation est possible uniquement si le matériel n'a pas encore été remis au Locataire. Aucun remboursement ne sera effectué une fois la location commencée. Le Locataire est responsable de disposer d'une connexion Wi-Fi adéquate lorsque celle-ci est nécessaire au fonctionnement du service.",
        text_online: '',
        text_cheque: '',
    },
    {
        title: "8. CONDITIONS D'UTILISATION DU MATÉRIEL",
        text:
            "Le matériel doit être utilisé uniquement en intérieur et ne doit pas être exposé à l'eau ou à l'humidité. Sont interdits : l'utilisation à des fins commerciales ou par ou au profit d'une entreprise ; tout usage autre que le karaoké ; le prêt ou le déplacement du matériel en dehors du lieu prévu sans autorisation écrite du Loueur ; le démontage, la modification ou toute tentative de réparation du matériel.",
        text_online: '',
        text_cheque: '',
    },
    {
        title: '9. SANCTIONS EN CAS DE NON-RESPECT',
        text:
            "Tout manquement aux présentes conditions peut entraîner l'utilisation de tout ou partie de la caution en cas de dommages, vol ou non-restitution, l'interdiction de toute future location auprès de Jénès Péyia Music et, lorsque cela est nécessaire, l'engagement de démarches judiciaires ou de recouvrement afin de protéger les droits du Loueur.",
        text_online: '',
        text_cheque: '',
    },
    {
        title: '10. ACCEPTATION DU CONTRAT',
        text:
            "Le Locataire reconnaît avoir pris connaissance du présent contrat et des conditions générales avant paiement et les accepter sans réserve au moyen de la case d'acceptation prévue dans le parcours de réservation. Cette acceptation électronique est enregistrée avec le numéro du contrat et sa date. Les constats et observations manuscrits inscrits lors de la remise ou de la restitution font partie intégrante du contrat. La prise en charge du matériel vaut reconnaissance de son état au départ sous réserve des anomalies consignées.",
        text_online: '',
        text_cheque: '',
    },
];

const ContractPreviewButton = () => {
    const [loading, setLoading] = React.useState(false);

    const openPreview = async () => {
        if (loading) return;

        setLoading(true);

        try {
            const token =
                localStorage.getItem('auth') || '';

            const response = await fetch(
                `${apiURL}/boxreservation/contract-preview`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (!response.ok) {
                throw new Error(
                    `HTTP ${response.status}`
                );
            }

            const blob = await response.blob();
            const url =
                window.URL.createObjectURL(blob);

            window.open(
                url,
                '_blank',
                'noopener,noreferrer'
            );

            window.setTimeout(
                () =>
                    window.URL.revokeObjectURL(url),
                60000
            );
        } catch (error) {
            console.error(error);

            window.alert(
                "Impossible d'afficher l'aperçu du contrat."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <button
            type="button"
            onClick={openPreview}
            disabled={loading}
            style={{
                border: 0,
                borderRadius: 4,
                padding: '8px 14px',
                cursor: loading
                    ? 'default'
                    : 'pointer',
                background: '#3f51b5',
                color: '#fff',
                fontWeight: 600,
                fontSize: 13,
            }}
        >
            {loading
                ? 'OUVERTURE...'
                : 'VOIR LE CONTRAT'}
        </button>
    );
};

const ContractForm = () => (
    <>
        <div style={{ marginBottom: 22 }}>
            <ContractPreviewButton />
        </div>

        <div style={{ marginBottom: 24 }}>
            <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 6 }}>
                Conditions de location
            </div>
            <div style={{ color: '#666', fontSize: 13 }}>
                Ces textes seront utilisés pour les nouveaux contrats Box Boukan.
            </div>
        </div>

        <ArrayInput source="sections" label="">
            <SimpleFormIterator disableReordering>
                <FormDataConsumer>
                    {({ getSource, scopedFormData }) =>
                        getSource ? (
                            <div style={{ width: '100%' }}>
                                <TextInput
                                    source={getSource('title')}
                                    label="Titre"
                                    fullWidth
                                />

                                {String(scopedFormData?.title || '').startsWith('3.') ? (
                                    <>
                                        <TextInput
                                            source={getSource('text_online')}
                                            label="Texte — caution en ligne"
                                            multiline
                                            rows={8}
                                            fullWidth
                                        />

                                        <TextInput
                                            source={getSource('text_cheque')}
                                            label="Texte — chèque de caution"
                                            multiline
                                            rows={8}
                                            fullWidth
                                        />
                                    </>
                                ) : (
                                    <TextInput
                                        source={getSource('text')}
                                        label="Texte"
                                        multiline
                                        rows={6}
                                        fullWidth
                                    />
                                )}
                            </div>
                        ) : null
                    }
                </FormDataConsumer>
            </SimpleFormIterator>
        </ArrayInput>

        <div style={{ marginTop: 30, marginBottom: 12 }}>
            <div style={{ fontWeight: 700, fontSize: 18 }}>
                Signature de l'entreprise
            </div>
            <div style={{ color: '#666', fontSize: 13, marginTop: 4 }}>
                Format PNG uniquement. Cette signature sera apposée automatiquement
                sur les nouveaux contrats.
            </div>
        </div>

        <FormDataConsumer>
            {({ formData }) =>
                formData?.signature_path ? (
                    <div style={{ marginBottom: 18 }}>
                        <div style={{ fontWeight: 600, marginBottom: 8 }}>
                            Signature actuellement enregistrée
                        </div>
                        <img
                            src={formData.signature_path}
                            alt="Signature actuelle"
                            style={{
                                maxWidth: 280,
                                maxHeight: 140,
                                objectFit: 'contain',
                                border: '1px solid #ddd',
                                padding: 10,
                                background: '#fff',
                            }}
                        />
                    </div>
                ) : null
            }
        </FormDataConsumer>

        <ImageInput
            source="signature"
            label="Téléverser une nouvelle signature PNG"
            accept="image/png"
        >
            <ImageField source="src" title="title" />
        </ImageInput>
    </>
);

export const BoxContractSettingsList = (props) => (
    <List
        {...props}
        bulkActionButtons={false}
        perPage={10}
        pagination={<AdminPagination />}
        exporter={false}
    >
        <AdminSelectableDatagrid>
            <TextField source="key" label="Configuration" />

            <FunctionField
                label="Conditions"
                render={(record: any) =>
                    `${Array.isArray(record.sections) ? record.sections.length : 0} section(s)`
                }
            />

            <FunctionField
                label="Signature"
                render={(record: any) =>
                    record.signature_path ? 'PNG enregistrée' : 'Non renseignée'
                }
            />

            <FunctionField
                label="Aperçu"
                render={() => <ContractPreviewButton />}
            />

            <EditButton />
        </AdminSelectableDatagrid>
    </List>
);

export const BoxContractSettingsEdit = (props) => (
    <Edit {...props} mutationMode="optimistic" title="Contrat Box Boukan">
        <SimpleForm redirect="list">
            <ContractForm />
        </SimpleForm>
    </Edit>
);

export const BoxContractSettingsCreate = (props) => (
    <Create {...props} title="Configuration du contrat Box Boukan">
        <SimpleForm
            redirect="list"
            initialValues={{
                key: 'global',
                sections: DEFAULT_CONTRACT_SECTIONS,
            }}
        >
            <ContractForm />
        </SimpleForm>
    </Create>
);
